import { render, staticRenderFns } from "./CertificateProcessType.vue?vue&type=template&id=48f7b2d8&scoped=true&"
import script from "./CertificateProcessType.vue?vue&type=script&lang=js&"
export * from "./CertificateProcessType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48f7b2d8",
  null
  
)

export default component.exports